import React from 'react'
import Home from './Home/Home'

import {Route,Routes} from 'react-router-dom'

import C from './C'
import { RecoilRoot } from 'recoil';
import ParticularAlert from './Home/ParticularAlert'
import StateWiseAlerts from './State/StateWiseAlerts'
import Earthquake from './Home/Earthquake'
import SearchAlerts from './SEARCHALERTS/SearchAlerts'
import Autocompletion from './SEARCHALERTS/Autocompletion'
import Navbar from './Navbar';
import Alertme from './Alertme';
import OtpNewlocation from './OtpNewlocation';
import Reg from './Reg';
import AgencyReg from './Agency/AgencyReg';
import AgencyProfilepage from './Agency/AgencyAchivements';
import AgencyAchivements from './Agency/AgencyAchivements';
import ViewAgency from './ViewAgency';
import Agen from './Agency/Agen';
import Agencylogin from './Agency/Agencylogin';
import ViewReportedDisaster from './ViewReportedDisaster';
import ReportDisaster from './ReportDisaster';
import YourReporting from './Agency/YourReporting';


export default function App() {
  return (<>



<Navbar/>


<RecoilRoot>


  <Routes>
 
<Route exact  path="/"   element={<Home/>}/> 

<Route exact  path="/specific"   element={<ParticularAlert/>}/> 
<Route exact  path="/statewisealert"   element={<StateWiseAlerts/>}/> 
<Route exact  path="/auto"   element={<Autocompletion/>}/> 
<Route exact  path="/earthq"   element={<Earthquake/>}/> 
<Route exact  path="/search"   element={<SearchAlerts/>}/> 
<Route exact  path="/alertme"   element={<Alertme/>}/> 
<Route exact  path="/alertmenewlocation"   element={<OtpNewlocation/>}/> 
<Route exact  path="/areg"   element={<Reg/>}/> 
<Route exact  path="/agencyreg"   element={<AgencyReg/>}/>  
<Route exact  path="/agencyachivements"   element={<AgencyAchivements/>}/>  
<Route exact  path="/viewagency"   element={<ViewAgency/>}/>  
<Route  exact path="/viewagency/:agenid"   element={<Agen/>}/>    
<Route  exact path="/agencysignin"   element={<Agencylogin/>}/>    
<Route  exact path="/viewreporteddisaster"   element={<ViewReportedDisaster/>}/>    
<Route  exact path="/reportdisaster"   element={<ReportDisaster/>}/>    
<Route  exact path="/yourreporting"   element={<YourReporting/>}/>    




</Routes>
</RecoilRoot>

  
  
  
  </>
   
  )
}
